<template>
  <b-modal
    :active.sync="showModal"
    trap-focus
    aria-role="dialog"
    aria-modal
    has-modal-card
    @close="closeModal"
  >
    <div class="modal-card" style="width: 700px" v-if="entry">
      <header class="modal-card-head">
        <p class="modal-card-title">
          Manage Team: #{{ entry.entrynumber }} - {{ entry.teamname }}
        </p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6 member-column">
            <p class="has-text-weight-bold">
              {{ entry.user.firstname }} {{ entry.user.surname }} (Captain)
            </p>
            <p>
              {{ entry.user.gender }}
            </p>
            <p>
              <a :href="`mailto:${entry.user.email}`">{{ entry.user.email }}</a>
            </p>
            <p>{{ entry.user.contactno }}</p>
          </div>
          <div
            class="column is-6 member-column"
            v-for="member in members"
            :key="member.id"
          >
            <p class="has-text-weight-bold" v-if="!member.user">
              {{ member.firstname }} {{ member.surname }}
            </p>
            <p class="has-text-weight-bold" v-if="member.dependant">
              {{ member.dependant.firstname }} {{ member.dependant.surname }}
            </p>
            <p class="has-text-weight-bold" v-else-if="member.user">
              {{ member.user.firstname }} {{ member.user.surname }}
            </p>
            <p v-if="!member.user">
              {{ member.gender }}
            </p>
            <p v-if="member.dependant">
              {{ member.dependant.gender }}
            </p>
            <p v-else-if="member.user">
              {{ member.user.gender }}
            </p>
            <p>
              <a :href="`mailto:${member.email}`">{{ member.email }}</a>
            </p>
            <p v-if="member.user">{{ member.user.contactno }}</p>
            <p>
              Account Linked:
              <b-icon
                v-if="member.user"
                class="text-success"
                icon="check"
              ></b-icon>
              <b-icon
                class="text-danger"
                v-if="!member.user"
                icon="close"
              ></b-icon>
            </p>
            <p>
              Waiver Accepted:
              <b-icon
                class="text-success"
                v-if="member.acceptwaiver"
                icon="check"
              ></b-icon>
              <b-icon
                class="text-danger"
                v-if="!member.acceptwaiver"
                icon="close"
              ></b-icon>
            </p>
            <div class="has-text-centered has-margin-top-10">
              <button class="button" @click="removeMember(member._id)">
                Remove
              </button>
            </div>
          </div>
        </div>
        <div>
          <div class="has-text-centered">
            <button
              class="button is-primary"
              @click="addMember()"
              v-if="!editing"
            >
              Add Member
            </button>
          </div>
          <ValidationObserver ref="observer" v-slot="{ passes }" v-if="editing">
            <p class="has-text-weight-bold is-size-5">Add Member</p>
            <form @submit.prevent="passes(saveMember)">
              <BaseInput
                v-model="member.firstname"
                label="First Name"
                rules="required"
              />
              <BaseInput
                v-model="member.surname"
                label="Surname"
                rules="required"
              />
              <BaseInput v-model="member.email" label="Email" rules="email" />
              <GenderSelect
                v-model="member.gender"
                label="Gender"
                rules="required"
              />
              <div class="has-margin-top-10">
                <button class="button" type="button" @click="editing = false">
                  Cancel
                </button>
                <button
                  class="button is-primary has-margin-left-5"
                  type="submit"
                  @click.prevent="passes(saveMember)"
                >
                  Save
                </button>
              </div>
            </form>
          </ValidationObserver>
        </div>
      </section>
      <footer class="modal-card-foot has-text-right">
        <button class="button" type="button" @click="closeModal">Close</button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import TeamMemberApi from '@/api/team-member'
import GenderSelect from '@/components/GenderSelect'

export default {
  name: 'ManageTeamModal',
  components: {
    GenderSelect,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    entry: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      showModal: this.show,
      item: null,
      members: [],
      editing: false,
      member: {},
    }
  },
  watch: {
    show() {
      this.showModal = this.show
    },
    entry() {
      this.item = this.entry
    },
  },
  async mounted() {
    await this.loadMembers()
  },
  methods: {
    addMember() {
      this.editing = true
      this.member = {
        event: this.entry.event,
        evententry: this.entry._id,
      }
    },
    async saveMember() {
      await TeamMemberApi.addMember(this.member)
      await this.loadMembers()
      this.editing = false
      this.$buefy.toast.open({
        message: 'Member added successfully.',
        position: 'is-top',
        type: 'is-success',
      })
    },
    closeModal() {
      this.showModal = false
      this.$emit('close-modal')
    },

    updateTeam() {
      this.loading = true
    },
    removeMember(id) {
      let vm = this
      this.$buefy.dialog.confirm({
        message: 'Are you sure you want to remove this team member?',
        onConfirm: async () => {
          await TeamMemberApi.removeMember(id)
          vm.members = vm.members.filter((item) => item._id != id)
          this.$buefy.toast.open({
            message: 'Member deleted successfully.',
            position: 'is-top',
            type: 'is-success',
          })
        },
      })
    },
    async loadMembers() {
      if (this.entry._id) {
        this.members = await TeamMemberApi.getMembers(this.entry._id)
      }
    },
  },
}
</script>

<style>
.member-column {
  padding-right: 5px;
  padding-top: 5px;
  border: 1px solid #eee;
}
</style>
